<ds-card class="flex-column p-6 card">
  <div
    (click)="collapsed = !collapsed"
    [ngClass]="{ 'mb-4': !collapsed }"
    class="d-flex justify-content-between cursor-pointer"
  >
    <h3 class="semi-bold">{{ props.label }}</h3>

    <img
      [ngClass]="{ rotated: !collapsed }"
      src="assets/icons/keyboard_arrow_down_travalign.svg"
      height="20"
      width="20"
      alt="keyboard_arrow_down"
    />
  </div>

  <ng-container *ngIf="!collapsed">
    <ng-container #fieldComponent />
  </ng-container>
</ds-card>
